/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsCustomWarning,
    SharedserviceMelcoModelsCustomWarningFromJSON,
    SharedserviceMelcoModelsCustomWarningFromJSONTyped,
    SharedserviceMelcoModelsCustomWarningToJSON,
    SharedserviceMelcoModelsDesignCollectionDefaultDesign,
    SharedserviceMelcoModelsDesignCollectionDefaultDesignFromJSON,
    SharedserviceMelcoModelsDesignCollectionDefaultDesignFromJSONTyped,
    SharedserviceMelcoModelsDesignCollectionDefaultDesignToJSON,
    SharedserviceMelcoModelsDesignListItem,
    SharedserviceMelcoModelsDesignListItemFromJSON,
    SharedserviceMelcoModelsDesignListItemFromJSONTyped,
    SharedserviceMelcoModelsDesignListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsDesignCollection
 */
export interface SharedserviceMelcoModelsDesignCollection {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignCollection
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignCollection
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesignCollection
     */
    design_count?: number;
    /**
     * 
     * @type {SharedserviceMelcoModelsDesignCollectionDefaultDesign}
     * @memberof SharedserviceMelcoModelsDesignCollection
     */
    default_design?: SharedserviceMelcoModelsDesignCollectionDefaultDesign;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsDesignListItem>}
     * @memberof SharedserviceMelcoModelsDesignCollection
     */
    design_list?: Array<SharedserviceMelcoModelsDesignListItem> | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsCustomWarning>}
     * @memberof SharedserviceMelcoModelsDesignCollection
     */
    warning_list?: Array<SharedserviceMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesignCollection
     */
    publish_state?: number;
    /**
     * 
     * @type {Date}
     * @memberof SharedserviceMelcoModelsDesignCollection
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SharedserviceMelcoModelsDesignCollection
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SharedserviceMelcoModelsDesignCollection
     */
    updated_date?: Date | null;
}

export function SharedserviceMelcoModelsDesignCollectionFromJSON(json: any): SharedserviceMelcoModelsDesignCollection {
    return SharedserviceMelcoModelsDesignCollectionFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsDesignCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsDesignCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'design_count': !exists(json, 'design_count') ? undefined : json['design_count'],
        'default_design': !exists(json, 'default_design') ? undefined : SharedserviceMelcoModelsDesignCollectionDefaultDesignFromJSON(json['default_design']),
        'design_list': !exists(json, 'design_list') ? undefined : (json['design_list'] === null ? null : (json['design_list'] as Array<any>).map(SharedserviceMelcoModelsDesignListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(SharedserviceMelcoModelsCustomWarningFromJSON)),
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
    };
}

export function SharedserviceMelcoModelsDesignCollectionToJSON(value?: SharedserviceMelcoModelsDesignCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'design_count': value.design_count,
        'default_design': SharedserviceMelcoModelsDesignCollectionDefaultDesignToJSON(value.default_design),
        'design_list': value.design_list === undefined ? undefined : (value.design_list === null ? null : (value.design_list as Array<any>).map(SharedserviceMelcoModelsDesignListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(SharedserviceMelcoModelsCustomWarningToJSON)),
        'publish_state': value.publish_state,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
    };
}


